import { render, staticRenderFns } from "./Breed.vue?vue&type=template&id=1bf876a2&scoped=true&lang=pug&"
import script from "./Breed.vue?vue&type=script&lang=js&"
export * from "./Breed.vue?vue&type=script&lang=js&"
import style0 from "./Breed.vue?vue&type=style&index=0&id=1bf876a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf876a2",
  null
  
)

export default component.exports